import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-generar-reportes-funcionarios',
  templateUrl: './generar-reportes-funcionarios.component.html',
  styleUrls: ['./generar-reportes-funcionarios.component.scss']
})

export class GenerarReportesFuncionariosComponent implements OnInit {

  public filtroReporte: number;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService) {
  }

  ngOnInit() {

    this.filtroReporte = 0;

  }

  /**
   * Método para regresar a la pantalla principal
   */
  public regresarListado() {
    this.router.navigate(['/main']);
  }

  /**
   * Método de control de Excepciones
   * @param error mensaje saliente respecto al error ocurrido
   * @param err   Tipo de error
   */
  cathException(error, err) {
    console.log(err);
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }
}
